import { jsx as r } from "react/jsx-runtime";
import l from "./index.es747.js";
import { CellAdditionalInfoWrapper as m } from "./index.es731.js";
import { Link as n } from "./index.es68.js";
const a = ({
  label: i,
  additionalInfo: e,
  ...o
}) => /* @__PURE__ */ r("div", { className: l.linkCellRoot, children: /* @__PURE__ */ r(m, { ...e, children: /* @__PURE__ */ r(n, { ...o, tabIndex: 0, size: "medium", children: i }) }) });
export {
  a as LinkCell
};
//# sourceMappingURL=index.es579.js.map
